import { Search, Filter } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

const ACTIVE_STATUS_OPTIONS: { value: 'all' | 'true' | 'false'; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  { value: 'true', label: 'Active' },
  { value: 'false', label: 'Inactive' },
]

interface StoresFiltersProps {
  searchInput: string
  onSearchChange: (value: string) => void
  regionInput: string
  onRegionChange: (value: string) => void
  isActive: 'all' | 'true' | 'false'
  onIsActiveChange: (value: 'all' | 'true' | 'false') => void
}

export function StoresFilters({
  searchInput,
  onSearchChange,
  regionInput,
  onRegionChange,
  isActive,
  onIsActiveChange,
}: StoresFiltersProps) {
  return (
    <div className="flex items-center gap-3 rounded-lg border border-border bg-card p-3">
      {/* Search Input */}
      <div className="relative flex-1 max-w-[352px]">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Search by name or number..."
          value={searchInput}
          onChange={e => onSearchChange(e.target.value)}
          className="pl-9 bg-muted/50"
        />
      </div>

      {/* Filter Icon */}
      <Filter className="h-6 w-6 text-muted-foreground" />

      {/* Region Input */}
      <Input
        placeholder="e.g. WEST"
        value={regionInput}
        onChange={e => onRegionChange(e.target.value)}
        className="w-[140px] bg-muted/50"
      />

      {/* Active Status Filter */}
      <Select
        value={isActive}
        onValueChange={value =>
          onIsActiveChange(value as 'all' | 'true' | 'false')
        }
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ACTIVE_STATUS_OPTIONS.map(option => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
